"use strict";

module.exports = [
  { level: "1", code: "en", label: "English" },
  { level: "2", code: "es", label: "Spanish" },
  { level: "3", code: "fr", label: "French" },
  { level: "4", code: "ja", label: "Japanese" },
  { level: "5", code: "zh", label: "Chinese" },
  { level: "6", code: "ko", label: "Korean" },
  { level: "7", code: "de", label: "German" }
];
